/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_A7Inputs */

const en_sorter_faq_a7 = /** @type {(inputs: Sorter_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, and that is deliberate. Array position usually carries meaning, such as ranking or sequence, so reordering elements would change your data rather than normalize its shape. Only object keys are reordered.`)
};

const ko_sorter_faq_a7 = /** @type {(inputs: Sorter_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`할 수 없고, 이는 의도된 것입니다. 배열의 위치는 순위나 순서처럼 보통 의미를 담고 있어서, 요소를 재배치하면 형태를 정규화하는 것이 아니라 데이터를 바꾸는 일이 됩니다. 객체 키만 재배치됩니다.`)
};

const ja_sorter_faq_a7 = /** @type {(inputs: Sorter_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`できません。これは意図的なものです。配列の位置は順位や順番のように通常意味を持つため、要素を並べ替えると形を正規化するのではなくデータを変えることになります。並べ替えられるのはオブジェクトキーだけです。`)
};

/**
* | output |
* | --- |
* | "No, and that is deliberate. Array position usually carries meaning, such as ranking or sequence, so reordering elements would change your data rather than no..." |
*
* @param {Sorter_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_a7 = /** @type {((inputs?: Sorter_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_a7(inputs)
	if (locale === "ko") return ko_sorter_faq_a7(inputs)
	return ja_sorter_faq_a7(inputs)
});